<template>
  <v-layout class="sso-view row wrap" :style="{backgroundColor: styles.general.theme_color_light}">
      <v-fade-transition>
        <v-flex xs12 v-if="mountDone">
            <div class="sso-card">
            <img :src="site_settings.styles.general.logo" style=""/>
            <h1>Signing in to Defense Exchange.</h1>
            <h2>{{ currentStatus }}</h2>
            <i class="fa fa-spin fa-spinner"></i>
            </div>
        </v-flex>
      </v-fade-transition>
  </v-layout>
</template>

<script>
import axios from 'axios'
export default {
  data () {
    return {
      mountDone: false,
      alert: true,
      currentStatus: 'Signing in...'
    }
  },
  computed: {
    loading () {
      return this.$store.getters.getLoading
    },
    site_settings () {
      return this.$store.getters.getSettings
    },
    styles () {
      return this.$store.getters.getStyles
    }
  },
  beforeCreate () {
    const urlParams = new URLSearchParams(window.location.search)
    const token = urlParams.get('token')
    if (!token) return window.location.replace('/')
  },
  mounted () {
    setTimeout(() => {
      this.mountDone = true
      this.verify(this.$route.query.token)
      // this.signInUser(this.$route.query.token)
    }, 2000)
  },
  methods: {
    verify (token) {
      return axios
        .get('https://us-central1-defense-exchange.cloudfunctions.net/api/verifyToken?type=exchange', {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then(res => {
          const customToken = res.data.token
          return this.signInUser(customToken)
        })
        .catch(() => {
          this.currentStatus = 'Signin failed. Redirecting...'
          setTimeout(() => {
            this.$router.replace('/sso-failed')
          }, 3000)
        })
    },
    updateCompanyDataSource (cid) {
      const uri = 'https://fed-exchange-api.herokuapp.com/api/v2.0/exchange-community-v2'
      return axios
        .post(uri, {
          id: cid,
          datasource: 'community-exchange'
        })
    },
    async signInUser (token) {
      await this.$firebase.auth().signOut()
      this.$store.dispatch('clearApp')
      this.$firebase.auth().signInWithCustomToken(token).then((data) => {
        const user = data && data.user ? data.user : data
        this.currentStatus = 'Signing in...'
        return this.$firebase.database().ref(`/users/${user.uid}`).once('value', async (userSnap) => {
          const userDetails = userSnap.val()
          if (userDetails) {
            await this.updateCompanyDataSource(userDetails.cid)
            await this.$store.dispatch('autoSignIn', userDetails)
            var logId = user.uid.slice(0, 10) + new Date(Number(user.metadata.b)).getTime()
            localStorage.setItem('logId', logId)
            this.$firebase.database().ref(`level_priviledge/${userDetails.role}`).on('value', (snapshot) => {
              var levelPrivileges = snapshot.val()
              this.$store.commit('setUserPrivilege', levelPrivileges)
            })
            if (userSnap.val().cid) {
              var companylegalname = userSnap.val().cid
              this.$firebase.database().ref('companies/' + companylegalname).once('value')
                  .then(
                    snapshot => {
                      let company = snapshot.val()
                      if (!company.otherinfo) {
                        let toolbarAlert = {
                          active: true,
                          type: 'warning',
                          message: `Please complete the <a href="/questionnaire"><b>company questionnaire<b></a> to take full advantage of the site`
                        }
                        this.$store.commit('setToolbarAlert', toolbarAlert)
                      }
                      this.$store.dispatch('setCompany', snapshot.val())
                    }
                  )
            }
            return this.$router.replace('/user/feed')
          } else {
            throw new Error('user not found.')
          }
        })
      }).catch(() => {
        this.currentStatus = 'Signing in failed. Redirecting...'
        setTimeout(() => {
          this.$router.replace('/')
        }, 3000)
      })
    }
  }
}
</script>

<style lang="scss">
  .sso-view {
    height: 100vh;
    width: 100%;
    padding-bottom: 30px;
    padding-top: 200px;
    position: relative;
    overflow: hidden;

    .sso-card {
      width: 500px;
      margin: 10px auto;
      text-align: center;
      img {
        max-width:100%;
        max-height:70px;
        display: block;
        margin: 20px auto;
      }
      h1, h2, h3, h4, h5 {
        color: #ffffff;
      }
      i {
        padding-top: 30px;
        font-size: 60px;
        color: #ffffff;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// SsoSigninView.vue?0f1ff9e8